(() => {
  if (window.sorbisAssistanceBound) return;
  window.sorbisAssistanceBound = true;
  const launcher = document.getElementById('sorbis-chat-invitation');
  if (!launcher) return;
  const visibleControls = new Set();
  let frame = 0;
  let restoreFocus = false;
  let requested = false;
  const chat = () => document.querySelector('shopify-chat');
  const isChatOpen = () => Boolean(chat()?.hasAttribute('open'));
  const syncPosition = () => {
    frame = 0;
    const open = isChatOpen();
    launcher.hidden = open || Boolean(document.querySelector('dialog[open]'));
    launcher.setAttribute('aria-expanded', String(open));
    if (launcher.hidden) return;
    const box = launcher.getBoundingClientRect();
    const active = document.activeElement;
    let obscured = Boolean(active?.matches('input, textarea, select, [contenteditable="true"]'));
    for (const control of visibleControls) {
      if (obscured) break;
      const rect = control.getBoundingClientRect();
      if (rect.width && rect.height && rect.left < box.right + 12 && rect.right > box.left - 12 && rect.top < box.bottom + 12 && rect.bottom > box.top - 12) obscured = true;
    }
    launcher.dataset.obscured = String(obscured);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(syncPosition);
  };
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) visibleControls.add(entry.target);
      else visibleControls.delete(entry.target);
    }
    schedule();
  });
  const observeControls = () => {
    observer.disconnect();
    visibleControls.clear();
    document.querySelectorAll('main a, main button, main input, main select, main textarea, main summary, main .sorbis-choice, main h1, main h2, main h3, main p').forEach(control => observer.observe(control));
    schedule();
  };
  document.querySelectorAll('.sorbis-open-chat').forEach(link => {
    link.addEventListener('click', event => {
      const component = chat();
      if (!component || !customElements.get('shopify-chat')) return;
      event.preventDefault();
      requested = true;
      restoreFocus = true;
      component.setAttribute('mode', 'standalone');
      component.setAttribute('open', '');
      schedule();
    });
  });
  customElements.whenDefined('shopify-chat').then(() => {
    const component = chat();
    if (!component) return;
    document.documentElement.classList.add('sorbis-chat-enhanced');
    component.removeAttribute('open');
    new MutationObserver(() => {
      if (isChatOpen() && !requested) {
        component.removeAttribute('open');
        schedule();
        return;
      }
      if (!isChatOpen() && restoreFocus) {
        requested = false;
        restoreFocus = false;
        launcher.hidden = false;
        launcher.dataset.obscured = 'false';
        launcher.focus({ preventScroll: true });
      }
      schedule();
    }).observe(component, { attributes: true, attributeFilter: ['open', 'mode'] });
    schedule();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && isChatOpen()) {
      requested = false;
      chat().removeAttribute('open');
    }
  });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('shopify:section:load', observeControls);
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  observeControls();
})();
